// Helpers for product size variants stored as JSON in products.variants
// Variant shape: { size: "1 Kg", price: 270, original_price: 300, enabled: true }

export const getVariants = (product) =>
  Array.isArray(product?.variants) ? product.variants.filter(v => v && v.size) : [];

export const hasVariants = (product) => getVariants(product).length > 0;

// enabled defaults to true when the key is missing
export const isVariantEnabled = (v) => v.enabled !== false;

export const getEnabledVariants = (product) => getVariants(product).filter(isVariantEnabled);

export const minVariantPrice = (product) => {
  const prices = getEnabledVariants(product).map(v => Number(v.price) || 0).filter(p => p > 0);
  return prices.length ? Math.min(...prices) : 0;
};
